import { Icon } from "@netilion/react-components";

type Props = {
  backgroundColor?: string;
  contentText?: string;
  icon?: string;
};

export default function StatusPill({
  backgroundColor = "",
  contentText = "",
  icon = "",
}: Props) {
  return (
    <div>
      {icon && (
        <div data-testid={`icon-${icon}`}>
          <Icon name={icon} />
        </div>
      )}
      <div
        className="status-pill"
        style={{ backgroundColor: `${backgroundColor}` }}
        data-testid={`status-pill-${backgroundColor}`}
      >
        {contentText && <span>{contentText}</span>}
      </div>
    </div>
  );
}
